import React, { useState } from "react";
import { Button, Modal, Box, Typography, CircularProgress } from "@mui/material";
import { useAuth } from "../../../../context/AuthContext";

const LogoutModal = ({ open, handleClose }) => {
  const { logout } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleConfirmLogout = async () => {
    setLoading(true); // Bloqueamos el botón para evitar múltiples clics
    try {
      await logout(); // Esperamos a que el PHP y Google revoquen el acceso
      handleClose();  
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={!loading ? handleClose : null} // Evita cerrar el modal mientras procesa
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={{ zIndex: 100020 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 300,
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography id="modal-title" variant="h6" component="h2" mb={2}>
          ¿Estás seguro de salir?
        </Typography>
        
        <Box display="flex" justifyContent="space-between" mt={3}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClose}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmLogout}
            disabled={loading}
            sx={{
              backgroundColor: "#F21D6B",
              color: "#fff",
              minWidth: "100px",
              "&:hover": {
                backgroundColor: "#c01756",
              },
            }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Salir"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default LogoutModal;